export enum Color {
  Default = 'default',
  Error = 'error',
  Success = 'success',
  Primary = 'primary',
  Secondary = 'secondary',
  Info = 'info',
  Warning = 'warning',
}
